@if (tenant(); as tenant) {
    <app-tenant-form
        mode="edit"
        [initialTenant]="tenant"
        [isSubmitting]="submitting()"
        (formSubmit)="onSubmit($event)"
    ></app-tenant-form>
} @else {
    <div class="loading"></div>
}
